module.exports = __webpack_public_path__ + "img/m6.a8bab6c7.jpg";